<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <v-card rounded>
          <PageBar :title="title" :back="true"/>
          <v-container fluid>
            <v-row>
              <v-col md="12" sm="12" cols="12">
                <v-text-field
                    label="Текущий пароль"
                    outlined
                    hide-details
                    dense
                    type="password"
                    v-model="old_password"
                    v-on:keyup.enter="pass_update"
                ></v-text-field>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-text-field
                    label="Новый пароль"
                    outlined
                    hide-details
                    dense
                    type="password"
                    v-model="new_password"
                    v-on:keyup.enter="pass_update"
                ></v-text-field>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-text-field
                    label="Повтор нового пароля"
                    outlined
                    hide-details
                    dense
                    type="password"
                    v-model="re_password"
                    v-on:keyup.enter="pass_update"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-divider/>
          <v-container fluid class="text-right">
            <v-btn color="primary" :loading="loading" @click="pass_update">
              Обновить
            </v-btn>
          </v-container>
        </v-card>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'AccountPassword',
  components: {
    PageBar: ()  => import('@/components/bar/Page.vue'),
  },
  data: () => ({
    title: "Изменение пароля",
    loading: false,
    old_password: '',
    new_password: '',
    re_password: ''
  }),
  methods: {
    pass_update() {
      this.loading = true;
      this.$http.post(`${this.$serverApiLink}account/update_password`, {
        'old_password': this.old_password,
        'new_password': this.new_password,
        're_password': this.re_password,
      }).then(
          response => {
            this.$store.commit('setSnack', {
              status: true,
              code: 200,
              message: response.data.message,
              type: 'success'
            });
            this.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            this.loading = false;
          }
      );
    }
  }
}
</script>